import { render, staticRenderFns } from "./SingIn.vue?vue&type=template&id=05cbc420&"
import script from "./SingIn.vue?vue&type=script&lang=js&"
export * from "./SingIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports